/**
 * Web3 钱包工具
 * 使用 MetaMask 原生 personal_sign 进行签名，确保前后端签名一致
 */

/**
 * 检查 MetaMask 是否安装
 */
export function hasMetaMask() {
  return typeof window.ethereum !== 'undefined'
}

/**
 * 获取钱包地址（触发 MetaMask 授权弹窗）
 */
export async function getWalletAddress() {
  if (!hasMetaMask()) throw new Error('请先安装 MetaMask 钱包')
  const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
  return accounts[0]
}

/**
 * 使用 MetaMask 原生 personal_sign 签名
 * 返回的签名可以直接在后端用 ethers.verifyMessage 验证
 */
export async function signMessage(message) {
  if (!hasMetaMask()) throw new Error('请先安装 MetaMask 钱包')
  const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  if (!accounts || accounts.length === 0) {
    // 没有授权账户，重新请求
    const accs = await window.ethereum.request({ method: 'eth_requestAccounts' })
    accounts[0] = accs[0]
  }
  const from = accounts[0]
  // 使用 personal_sign，签名内容与 ethers.verifyMessage 标准一致
  const signature = await window.ethereum.request({
    method: 'personal_sign',
    params: [message, from]
  })
  return signature
}

/**
 * 截断地址显示
 */
export function shortAddress(address) {
  if (!address) return ''
  return address.slice(0, 6) + '...' + address.slice(-4)
}

/**
 * 格式化金额
 */
export function formatAmount(value, decimals = 2) {
  if (value === null || value === undefined) return '0.00'
  return Number(value).toFixed(decimals)
}
